import { createContext } from 'react';
import type { AuthUser,rolesList } from '../../types/Users';

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  userRole?: rolesList;
  user : AuthUser | null;
  login: (username:string,password:string) => Promise<AuthUser |null>;
  logout: () => void;
  hasRole: (role:rolesList) => boolean;
  isRole:(role:rolesList) => boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);
export default AuthContext;